// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"b2e9cfe0","707":"3424a9dc","729":"f7fbea8a"}[chunkId] + ".js";
};